import { ApiStatus } from "./api.types";

export const LOCATION_TYPES = ["warehouse", "outlet", "bar", "kitchen", "retail"] as const;
export const NEGATIVE_STOCK_POLICIES = ["block", "allow_and_flag"] as const;

export interface Location {
  _id: string;
  account?: string;
  name: string;
  code: string;
  type: string;
  parentLocationId?: any;
  addressId?: any;
  negativeStockPolicy?: string | null;
  isActive: boolean;
  isDefault?: boolean;
}

export interface LocationSliceState {
  locations: Location[];
  locationDetails: any;
  rowCount: number;
  status: ApiStatus;
  errorMessage?: string;
  isLocationCreated: boolean;
  selectedLocationId: string;
}

export interface LocationUpdatePayload {
  id: string;
  locationPayload: any;
}
